module.exports = __webpack_public_path__ + "static/media/video-add-button.b0e29d79.svg";